module.exports = __webpack_public_path__ + "static/media/place.af97ca02.svg";